export default "__VITE_ASSET__f7b66548__"